import type { SkillMeta } from '../Skill';

// Connector 관련 인터페이스
export interface ConnectorSkill {
  name: string;
  displayName: string;
  description: string;
  needApprovalToRun: boolean;
  tags: string[];
  examples: string[];
}

export interface Connector {
  name: string | null;
  displayName: string | null;
  description: string | null;
  iconUri: string | null;
  useCases?: string[]; // Deprecated: examples 대체 예정 (하위 호환성을 위해 유지 가능)
  examples?: string[]; // 신규 추가
  createdBy?: string | null;
  skillCount?: number;
  hasNeedApprovalSkills?: boolean;
  skills?: ConnectorSkill[];
  userConnectorType: 'Connector' | 'Mcp';
}

export interface ConnectorListResponse {
  connectors: Connector[];
  companyCode: string;
  type: string;
  id: string;
  partitionKey: string;
  updatedTime: string;
  createdTime: string;
  deletedTime: string;
  deleted: boolean;
}

// UserConnector 인터페이스 (GET /api/connector/list 응답용)
export interface UserConnector {
  id?: string | null;
  partitionKey?: string | null;
  updatedTime: string;
  createdTime: string;
  deletedTime: string;
  deleted: boolean;
  isEnabled: boolean;
  companyCode?: string | null;
  userId?: string | null;
  connectorType?: string | null;
  displayName?: string | null;
  userName?: string | null;
  userDisplayName?: string | null;
  iconUri?: string | null;
  settings?: Record<string, string> | null;
  needAttention: boolean;
  needAttentionReason: string;  // 'None' | 'Authorization' | 등
  needAttnetionReasonDetail?: string | null;
  credential?: any; // 인증 토큰 정보 등
  connector?: Connector; // 커넥터 상세 정보
  userConnectorType: 'Connector' | 'Mcp';
  tools?: IMCPTool[];
}

export interface MCPConnectorTool{
  name: string,
  description: string,
  isOn: boolean,
}

export interface UserConnectorListResponse {
  data: UserConnector[];
  totalCount: number;
  continuationToken?: string | null;
}

// MCP Server 관련 인터페이스
export interface MCPServer {
    command: string;
    args: string[];
    runtime?: string;
  env?: Record<string, any>;
  }
  
export interface MCPServersConfig {
    mcpServers: Record<string, MCPServer>;
  }

export interface ToolState {
  localMcpTools: Record<string, IMCPTool[]>;
  connectors: UserConnectorListResponse;
  skills: SkillMeta[];
}

// 리소스 정보를 위한 인터페이스 (실제 리소스 구조에 맞게 조정 필요)
export interface IMCPTool {
  name: string;
  description?: string;
  inputSchema?: {
    type: "object";
    properties: Record<string, object>; // 중요!
    required?: string[];
  };
  annotations?: Record<string, object>;
  id?: string;
  enabled: boolean;
}

export interface IMCPResponse {
  toolName: string;
  arguments: Record<string, object>;
  content?: IMCPContext[];
}

export interface IMCPContext {
  type: string;
  text: string;
  }

export interface IMCPRequest{
  toolName: string;
  arguments: any;
}

export const initialState: ToolState = {
  localMcpTools: {},
  connectors: {data: [], totalCount: 0},
  skills: []
};

// Tool Detail Types & Utils
export interface ToolCapabilityParam {
  name: string;
  description: string;
  required?: boolean; // true='필수', false='선택'
}

export interface ToolCapability {
  title: string;
  description: string;
  params?: ToolCapabilityParam[];
  requiresConfirmation?: boolean; // '실행 전 사용자에게 확인'
}

